export default "{{content}}"